import { DropDownQuestionConfig } from '@hyper-inferno/drop-down-single-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
export class DropDownSingleChoiceHandler
  implements QuestionHandler<DropDownQuestionConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }
}
